const LIMIT_NOT_ALLOW_RESIZE_FORMAT = ['gif', 'svg'];

export const isFileTypeNotResizable = (fileType: string) => {
  return LIMIT_NOT_ALLOW_RESIZE_FORMAT.some((format) =>
    fileType.includes(format)
  );
};
